import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { get } from 'lodash-es';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { getModelState } from 'client/data/luckdragon/model';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { CmsEntities, CmsModel, bindToContent } from 'client/data/models/cms';
import { buildPubStateModelYearPath, VehicleModel } from 'client/data/models/vehicle-v2';
import { getPageLinksPath, LinkWidgetsModel } from 'client/data/models/link-widgets';
import { DEFAULT_CONTENT, parseContent } from 'client/data/cms/content';
import { getMeta, getSeoImage } from 'site-modules/shared/utils/seo-helper';
import { getFAQSchema } from 'client/seo/schemas/faq';
import { getQAEntriesFromContent } from 'client/site-modules/shared/utils/faq';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getBaseBreadcrumb, getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';
import { SearchByModule } from 'site-modules/shared/components/search-by-module/search-by-module';
import { AppraisalInfoSection } from 'site-modules/appraisal/components/appraisal-info-section/appraisal-info-section';
import { TrackingHandler } from 'client/tracking/handler';
import { MMZ_TRACKING_IDS } from 'client/tracking/maps/appraisal';
import { AppraisalLandingMap } from 'client/tracking/maps/appraisal/appraisal-landing';
import { PageLinksWidget } from 'site-modules/shared/components/page-links-widget/page-links-widget';
import { URL_PATHS } from 'site-modules/shared/constants/appraisal/paths';
import { REVIEWS_MODULE_USER_REVIEW_CONTENT_PATH } from 'site-modules/shared/components/offers-reviews-module/constants';
import { AppraisalTabsContainer } from 'site-modules/shared/components/appraisal/appraisal-tabs-container/appraisal-tabs-container';
import { SuggestedVehiclePricingCarouselContainer } from 'site-modules/shared/components/suggested-vehicle-pricing-carousel/suggested-vehicle-pricing-carousel-container';
import { MinHeightWrapper } from 'site-modules/shared/components/min-height-wrapper/min-height-wrapper';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';
import { setCriticalCss } from 'client/actions/critical-css';
import { PUB_STATES } from 'client/constants/pub-states';
import { isAddressToVinExcludedState } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/utils/is-address-to-vin-excluded-state';
import { getInitialTabIdFromLocation } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/utils/get-initial-tab-id-from-location';
import { AppraisalLandingHeadingSection } from 'site-modules/appraisal/components/appraisal-landing-heading-section/appraisal-landing-heading-section';
import { getIsOptimizedTraffic } from 'site-modules/shared/utils/appraisal/optimized-traffic';
import { PrivatePartySellCarWidget } from 'client/site-modules/shared/components/private-party/private-party-sell-car/private-party-sell-car-widget';
import { Experiment, Recipe } from 'site-modules/shared/components/experiment';
import { AppraisalTabsContainer as AppraisalTabsContainerV2 } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/appraisal-tabs';
import { ExperimentUtil } from 'client/utils/experiment/experiment-util';
import { MrectNative } from 'site-modules/shared/components/native-ad/mrect/mrect-native';
import { LeaderboardNative } from 'site-modules/shared/components/native-ad/leaderboard/leaderboard-native';

import 'site-modules/shared/components/appraisal/appraisal-common.scss';
import './appraisal.scss';
import './appraisal-landing.scss';

export const PAGE_DISPLAY_NAME = 'Car Value';
export const APPRAISAL_CONTENT_FILE_PATH = 'research/appraisal/index';

export class AppraisalUI extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    isAppExtensionPage: PropTypes.bool,
    content: CmsEntities.Content,
    location: PropTypes.shape({}),
    visitorLocation: PropTypes.shape({}),
  };

  static defaultProps = {
    isMobile: false,
    isAppExtensionPage: false,
    content: DEFAULT_CONTENT,
    location: {},
    visitorLocation: {},
  };

  state = {
    make: null,
    model: null,
    year: null,
    validated: false,
    isEstimate: false,
    isUtmAccountAppraisal: false,
    isUtmSourceFacebook: false,
  };

  componentDidMount() {
    TrackingHandler.useMap(AppraisalLandingMap);
  }

  renderAppraisalTabsContainer = additionalProps => {
    const { isMobile, isAppExtensionPage, location, visitorLocation } = this.props;
    const isOptimizedFunnelTraffic = getIsOptimizedTraffic({ isAppExtensionPage, location });
    const renderAddressTab = !isAddressToVinExcludedState(visitorLocation);
    const tabsProps = {
      isBackgroundStyleTabEnabled: true,
      isFullWidth: true,
      isMobile,
      isAppExtensionPage,
      className: classnames({
        'mb-0_5': !isOptimizedFunnelTraffic,
        'mb-2': isOptimizedFunnelTraffic,
      }),
      isProfileOfferVinPrepopulationEnabled: true,
      hasAddressToVinDrawer: !(isAddressToVinExcludedState(visitorLocation) || isOptimizedFunnelTraffic),
      isAppraisalLanding: true,
      ctaBtnColor: 'blue-50',
      renderAddressTab,
      ...additionalProps,
    };

    return (
      <Experiment name="EMO-3500" showDefault>
        <Recipe name="ctrl" isDefault>
          <AppraisalTabsContainer {...tabsProps} />
        </Recipe>
        <Recipe name="chal1">
          <AppraisalTabsContainerV2 {...tabsProps} />
        </Recipe>
      </Experiment>
    );
  };

  render() {
    const { content, isMobile, isAppExtensionPage, location } = this.props;
    const title = get(content, 'title', PAGE_DISPLAY_NAME);
    const subheader = content.child('html').content || '';
    const isOptimizedFunnelTraffic = getIsOptimizedTraffic({ isAppExtensionPage, location });
    const breadcrumbs = [getHomeBreadcrumb(), getBaseBreadcrumb(PAGE_DISPLAY_NAME, URL_PATHS.APPRAISAL_LANDING)];

    return (
      <main
        id="main-content"
        tabIndex={-1}
        className="appraisal appraisal-landing"
        data-tracking-parent="appraisal-landing-page"
      >
        <AppraisalLandingHeadingSection
          title={title}
          subheader={subheader}
          breadcrumbs={breadcrumbs}
          renderAppraisalTabs={this.renderAppraisalTabsContainer}
          isAppExtensionPage={isAppExtensionPage}
        />
        <Container className="mt-2 mt-md-0">
          <Col xs={12} lg={10} className="px-0">
            <PrivatePartySellCarWidget isMobile={isMobile} />
          </Col>
        </Container>

        <Experiment name="ads-12560" showDefault>
          <Recipe name="ctrl" isDefault />
          <Recipe name="chal">
            <Container className=" mt-2">
              <Col xs={12} lg={10} className="px-0">
                {isMobile ? (
                  <MrectNative position={'1'} mobileOnly useMinHeight />
                ) : (
                  <LeaderboardNative
                    position={'2'}
                    wiredBreakpoints={{ md: true, lg: true, xl: true }}
                    noRefresh
                    refreshZones={null}
                    showLabel={false}
                    useMinHeight
                  />
                )}
              </Col>
            </Container>
          </Recipe>
        </Experiment>

        <Container>
          <Row>
            <Col xs={12} lg={10}>
              {!isOptimizedFunnelTraffic && (
                <div className="mt-2">
                  <ErrorBoundary>
                    <AppraisalInfoSection
                      howItWorksContent={content.child('how-it-works')}
                      articlesContent={content.child('articles')}
                      faqContent={content.child('faq')}
                      isMobile={isMobile}
                      pathname={location.pathname}
                    />
                  </ErrorBoundary>
                  <hr className="mt-1_5 mb-2" />
                  <section>
                    <h2 className="heading-3 mb-0">Shop used cars</h2>
                    <ErrorBoundary>
                      <SearchByModule
                        location={location}
                        isMobile={isMobile}
                        trackingMap={MMZ_TRACKING_IDS}
                        isUsed
                        isSmallContainer={!isMobile}
                        contentClassName="bg-white"
                      />
                    </ErrorBoundary>
                  </section>
                </div>
              )}
            </Col>
          </Row>
          {!isOptimizedFunnelTraffic && (
            <Fragment>
              <hr className="mt-1_5 mb-2" />
              <MinHeightWrapper
                className="suggested-pricing-wrapper show-separator"
                componentType="SUGGESTED_PRICING_CAROUSEL"
              >
                <SuggestedVehiclePricingCarouselContainer className="px-0" />
              </MinHeightWrapper>
              <PageLinksWidget divideSections={false} title="Related information" hasTopDivider />
            </Fragment>
          )}
        </Container>
      </main>
    );
  }
}

export const mapStateToProps = state => ({
  isMobile: state.mobile,
  location: get(state, 'pageContext.location'),
  isAppExtensionPage: get(state, 'pageContext.isAppExtensionPage'),
  isAuthenticated: get(state, 'profile.isAuthenticated'),
  visitorLocation: get(state, 'visitor.location'),
});

export const stateToPropsConfig = {
  content: bindToContent(APPRAISAL_CONTENT_FILE_PATH),
};

export const Appraisal = connect(mapStateToProps)(connectToModel(AppraisalUI, stateToPropsConfig));

const preload = (store, isPreloadAboveFold = false) => {
  const state = store.getState();
  const { pageContext } = state;
  const preloader = new ModelPreloader(store);

  const location = get(pageContext, 'location');
  const isAppExtensionPage = get(pageContext, 'isAppExtensionPage');
  const referer = get(pageContext, 'page.referer');
  preloader.resolve(`content["${APPRAISAL_CONTENT_FILE_PATH}"]`, CmsModel);
  preloader.resolve(getPageLinksPath(), LinkWidgetsModel);
  preloader.resolve(buildPubStateModelYearPath([PUB_STATES.NEW_USED, PUB_STATES.USED]), VehicleModel);

  if (!isPreloadAboveFold) {
    preloader.resolve(`content["${REVIEWS_MODULE_USER_REVIEW_CONTENT_PATH}"]`, CmsModel);
  }

  return preloader.load().then(() => {
    const isOptimizedFunnelTraffic = getIsOptimizedTraffic({ location, isAppExtensionPage });
    const appraisalTabsRecipe = ExperimentUtil.getForcedOrAssignedRecipeName({
      state,
      campaignName: 'EMO-3500',
      defaultVal: 'ctrl',
    });
    const initialTabId = getInitialTabIdFromLocation({
      location,
      isLicensePlateTabDefault: false,
      isSellCar: false,
      referer,
    });

    store.dispatch(
      setCriticalCss({
        isOptimizedFunnelTraffic, // 2 values
        isAppExtensionPage: pageContext.isAppExtensionPage, // 2 values
        initialTabId, // 3 values
        appraisalTabsRecipe, // 2 values
      })
    );
  });
};

export const pageDefinitionConfiguration = {
  name: 'used_cars_tmv_appraiser',
  category: 'used_cars_tmv_appraiser',
  preload: store => preload(store),
  preloadAboveFold: store => preload(store, true),
  seo: (state, props) => {
    const modelState = getModelState(state);
    const content = modelState.get(`content["${APPRAISAL_CONTENT_FILE_PATH}"]`, CmsModel);
    const parsedContent = parseContent(content);
    return {
      ...getMeta(parsedContent),
      image: getSeoImage(parsedContent),
      jsonld: [
        getFAQSchema({
          entries: getQAEntriesFromContent(parsedContent.child('faq')),
          generateLearnMoreLinks: true,
          pathname: get(props, 'location.pathname'),
        }),
        getBreadcrumbSchema([getHomeBreadcrumb(), getBaseBreadcrumb(PAGE_DISPLAY_NAME, URL_PATHS.APPRAISAL_LANDING)]),
      ],
    };
  },
  component: Appraisal,
};

export default pageDefinition(pageDefinitionConfiguration);
